const AUCTION_AREA = {
  1: 'BIENES',
  2: 'PROPIEDADES',
  BIENES: 1,
  PROPIEDADES: 2,
};
const AUCTION_TYPE = {
  REMATE: { PROPIEDADES: 1, BIENES: 2 },
  LICITACION: { PROPIEDADES: 4, BIENES: 3 },
  REMATE_LICITACION: 5,
};

export { AUCTION_AREA, AUCTION_TYPE };
